import useBodyEditor from './useBodyEditor';
import BodyEditorDlg from './UI/BodyEditorDlg';
import bodyEditorEngine from './Core/BodyEditorEngine';

/**
 * BodyEditorWidget — mounts the floating WYSIWYG body editor dialog.
 * Add once to App.jsx next to CalendarWidget:
 *   <BodyEditorWidget />
 * Comment out to disable the feature entirely.
 */
export default function BodyEditorWidget() {
    const { isOpen, entry } = useBodyEditor();

    return (
        <BodyEditorDlg
            open={isOpen}
            entry={entry}
            onClose={() => bodyEditorEngine.close()}
        />
    );
}
